import { isValid, parseISO } from 'date-fns';

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const DATE_TIME_PREFIX_REGEX = /^(\d{4}-\d{2}-\d{2})T/;

const pad = value => String(value).padStart(2, '0');

export const buildDateOnlyFromDate = value =>
  [value.getFullYear(), pad(value.getMonth() + 1), pad(value.getDate())].join(
    '-'
  );

export const todayDateOnly = () => buildDateOnlyFromDate(new Date());

export const extractDateOnlyValue = value => {
  if (value === null || value === undefined || value === '') return '';

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? '' : buildDateOnlyFromDate(value);
  }

  const rawValue = String(value).trim();
  if (!rawValue) return '';

  if (DATE_ONLY_REGEX.test(rawValue)) {
    return rawValue;
  }

  const dateTimeMatch = rawValue.match(DATE_TIME_PREFIX_REGEX);
  if (dateTimeMatch) {
    return dateTimeMatch[1];
  }

  const parsedDate = parseISO(rawValue);
  if (!isValid(parsedDate)) {
    return '';
  }

  return buildDateOnlyFromDate(parsedDate);
};

export const isValidDateOnlyValue = value => {
  const dateOnlyValue = extractDateOnlyValue(value);
  if (!dateOnlyValue) return false;

  const parsedDate = parseISO(`${dateOnlyValue}T12:00:00`);
  return (
    isValid(parsedDate) && buildDateOnlyFromDate(parsedDate) === dateOnlyValue
  );
};

export const formatDateOnlyForDisplay = value => {
  const dateOnlyValue = extractDateOnlyValue(value);
  if (!dateOnlyValue) return '';

  const [year, month, day] = dateOnlyValue.split('-').map(Number);
  return new Date(year, month - 1, day, 12, 0, 0, 0).toLocaleDateString();
};
